import {
  jb_cta_small_css_default
} from "./chunk.2V5F43X5.js";
import {
  Linkable,
  getLinkIcon,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.MFPI4EPN.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  isPartiallyInViewPort
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-cta-small/jb-cta-small.ts
var JbCtaSmall = class extends Linkable(r) {
  constructor() {
    super(...arguments);
    this.alwaysVisible = false;
    this._ctaSmall = {
      el: null,
      hero: null,
      text: null,
      footer: null
    };
    this._expandedWidth = 0;
    this._isHovered = false;
    this._isVisible = false;
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this._ctaSmall.el = this.renderRoot.querySelector(".cta-small");
    this._ctaSmall.hero = document.querySelector(
      "jb-info-page-hero, jb-campaign-page-hero-fullscreen, jb-article-page-hero, jb-moment-page-hero, jb-news-page-hero, jb-simple-page-hero"
    );
    this._ctaSmall.text = this.renderRoot.querySelector(".text");
    this._ctaSmall.footer = document.querySelector("jb-footer");
    if (!this._ctaSmall.el) return;
    if (this.link.data.type === "download" && this.link?.href) {
      this._ctaSmall.el?.setAttribute("download", "");
    }
    this._expandedWidth = this.shadowRoot.querySelector("span")?.offsetWidth;
    this._ctaSmall.el.addEventListener("mouseover", () => this._mouseOver());
    this._ctaSmall.el.addEventListener("mouseout", () => this._mouseOut());
    this._ctaSmall.el.addEventListener("focus", () => this._mouseOver());
    this._ctaSmall.el.addEventListener("focusout", () => this._mouseOut());
    window.addEventListener("scroll", () => this._showHide());
    setTimeout(() => {
      this._showHide();
    }, 0);
  }
  _aboveTheFold() {
    const viewportHeight = window.innerHeight;
    if (this._ctaSmall.hero) {
      const heroBottomEdgeOffset = this._ctaSmall.hero.getBoundingClientRect().bottom;
      return heroBottomEdgeOffset > viewportHeight / 2;
    }
    const scrollPosition = window.scrollY;
    return scrollPosition < viewportHeight / 2;
  }
  _mouseOut() {
    this._isHovered = false;
  }
  _mouseOver() {
    this._isHovered = true;
    this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    this._ctaSmall.el?.setAttribute("aria-expanded", "true");
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 200);
  }
  _showHide() {
    if (!this.alwaysVisible && (this._aboveTheFold() || this._ctaSmall.footer && isPartiallyInViewPort(this._ctaSmall.footer))) {
      this._isVisible = false;
    } else {
      this._isVisible = true;
    }
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "cta-small",
      interaction_element: "cta"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <a
        @jb-link:clicked=${this._tracking}
        data-fly-tweak="0,0,${this._expandedWidth ? this._expandedWidth + 24 : 0},-${this._expandedWidth ? this._expandedWidth + 24 : 0}"
        data-linkable
        class="cta-small ${Rt({
      [this.link.data.type]: this.link.data.type,
      "cta-small--hover": this._isHovered,
      "cta-small--visible": this._isVisible
    })}"
        tabindex="${this.alwaysVisible || this._isVisible ? "0" : "-1"}"
        aria-expanded="${!this.alwaysVisible ? "false" : D}"
      >
        <span
          class="text"
          data-fly-catcher
        >
          <span class="text-wrap">${this.text}</span>
        </span>
        <span class="icon">${getLinkIcon(this.link.data.type)}</span>
      </a>
    `;
  }
};
JbCtaSmall.styles = [reset_css_default, jb_cta_small_css_default];
__decorateClass([
  n({ type: Boolean })
], JbCtaSmall.prototype, "alwaysVisible", 2);
__decorateClass([
  n()
], JbCtaSmall.prototype, "text", 2);
__decorateClass([
  r2()
], JbCtaSmall.prototype, "_isHovered", 2);
__decorateClass([
  r2()
], JbCtaSmall.prototype, "_isVisible", 2);
JbCtaSmall = __decorateClass([
  customElement("jb-cta-small")
], JbCtaSmall);

export {
  JbCtaSmall
};
